import CountryMap from './CountryMap';

export default CountryMap;
